import { DIMENSIONS_LANG } from './consts';

export const isArrayNotEmpty = (array) => {
    return array?.length > 0;
}

export const isArraysNotEmpty = (arrays) => {
    for (let i = 0; i < arrays.length; i++) {
        if (isArrayEmpty(arrays[i]))
            return false;
    }
    return true;
}

export const isArrayEmpty = (array) => {
    return !isArrayNotEmpty(array);
}

export const isArrayMinSize = (array, minSize) => {
    return array?.length >= minSize;
}

export const getVal = (array, key) => {
    for (let i = 0; i < array.length; i++) {
        if (array[i].key === key)
            return array[i].value;
    }
    return null;
}

export const getAllValues = (array, key) => {
    let allValues = [];
    for (let i = 0; i < array.length; i++) {
        if (array[i].key === key) {
            allValues.unshift(array[i].value); //add the element to the beginning of the array
        }
    }
    return allValues;
}

export const getValueFromJson = (json, key1, key2 = '') => {
    if (!json || !key1 || !json[key1]) return;
    if (key2) {
        return json[key1][key2];
    } else {
        return json[key1];
    }
}

// export const getMultiArrayFromCollection = (collection) => {
//     let values = Object.values(collection);
//     let keys = Object.keys(collection);
//     let newArray = [];

//     for (let i = 0; i < keys.length; i++) {
//         newArray[i] = { 'id': keys[i], 'nameHe': values[i] };
//     }
//     return newArray;
// }

export const removeOrphanChildren = (children, parents, dimension, id) => {
    if (isArrayNotEmpty(children)) {
        let parentsArray = [];
        for (let i = 0; i < children.length; i++) {
            let child = children[i];
            let parent = dimension[child][id];
            let findParent = parents.find((x) => x === parent)

            parentsArray[i] = findParent ? findParent : null;
        }

        for (let i = 0; i < children.length; i++) {
            if (parentsArray[i] === null)
                children[i] = null;
        }

        children = children.filter(val => { return val !== null; });
    }
    return children;
}

export const stringBuilderFromArray = (array, keys, localization) => {
    let allValues = '';
    if (keys.length === 1) {
        allValues = array[keys[0]][DIMENSIONS_LANG];
    }
    else {
        for (let i = 0; i < keys.length; i++) {
            allValues += array[keys[i]][DIMENSIONS_LANG];
        }
        const grade = localization.labels.repositoryManagement.grade;
        allValues = localization.labels.repositoryManagement.grades + ' ' + allValues.replaceAll(grade, ', ').replace(',', '');
    }
    return allValues;
}

export const isParentFound = (dimension, child, itemDimension) => {
    let isFound = false;
    if (dimension && itemDimension) {
        let parentDimension = dimension.filter(x => x.key === child);
        itemDimension.forEach(element => {
            if (parentDimension.find(x => x.value === element)) {
                isFound = true;
                return;
            }
        });
    }
    return isFound;
}

export const separator = ": ";

export const removeSeparator = (string) => {
    if (string.startsWith(separator)) {
        return string.replace(separator, '');
    }
    return string;
}


export const addPrefixForItems = (array, dimension, dimensionParent, idFieldName, parentDimensionName) => {
    for (let i = 0; i < array.length; i++) {
        let currentId = dimension[array[i].id][idFieldName];
        if (currentId) {
            currentId = currentId.trim();
            if (dimensionParent && dimensionParent[currentId] && dimensionParent[currentId][DIMENSIONS_LANG]) {
                let prefix = dimensionParent[currentId][DIMENSIONS_LANG];
                dimension[array[i].id][DIMENSIONS_LANG] = prefix + separator + array[i][DIMENSIONS_LANG];
            }
            else {
                console.error(`Can't find ${idFieldName}: ${currentId} at ${parentDimensionName}`);
            }
        } else {
            console.error(`Can't find ${idFieldName} at ${parentDimensionName}`);
        }
    }
}

export const addPrefixForSyllabusSubjects = (array, syllabusDisciplines, syllabusAgeGrades, dimensions, localization) => {
    for (let i = 0; i < array.length; i++) {
        let disciplineName = getVal(syllabusDisciplines, array[i].id);
        let ageGradeNames = getAllValues(syllabusAgeGrades, array[i].id);
        if (dimensions.disciplines && dimensions.disciplines[disciplineName] && dimensions.disciplines[disciplineName][DIMENSIONS_LANG]) {
            let prefix = dimensions.disciplines[disciplineName][DIMENSIONS_LANG] + " - "
                + stringBuilderFromArray(dimensions.ageGrades, ageGradeNames, localization);
            dimensions.syllabusSubjects[array[i].id][DIMENSIONS_LANG] = prefix + separator + array[i][DIMENSIONS_LANG];
        }
        else {
            console.error("Can't find disciplineName: " + disciplineName);
        }
    }
}

export const addPrefixForSkills = (array, skillsDisciplines, skillsAgeGrades, dimensions, localization) => {
    for (let i = 0; i < array.length; i++) {
        let skillId = array[i].id;
        let prefix;
        let disciplineName = getVal(skillsDisciplines, skillId);
        let ageGradeNames = getAllValues(skillsAgeGrades, array[i].id);
        prefix = (dimensions.disciplines[disciplineName] ? dimensions.disciplines[disciplineName][DIMENSIONS_LANG] + ' - ' : '')
            + stringBuilderFromArray(dimensions.ageGrades, ageGradeNames, localization, DIMENSIONS_LANG);
        dimensions.skills[array[i].id][DIMENSIONS_LANG] = prefix + separator + array[i][DIMENSIONS_LANG];
    }
}

export const getFilteredArrayByOneParam = (itemDimension, arrayToFilter, idFieldName) => {
    return isArrayNotEmpty(itemDimension) ? (arrayToFilter.filter(x => itemDimension.indexOf(x[idFieldName]) >= 0)) : [];
}

export const removeChildren_syllabusSkills = (children, disciplines, grades, itemDimensions) => {
    if (isArrayNotEmpty(children)) {
        let parentsArray = [];
        for (let i = 0; i < children.length; i++) {
            let child = children[i];

            let findDiscipline = disciplines ? isParentFound(disciplines, child, itemDimensions.disciplines) : true;
            let findAgeGrade = isParentFound(grades, child, itemDimensions.ageGrades);

            parentsArray[i] = (findDiscipline && findAgeGrade) ? true : null;
        }

        for (let i = 0; i < children.length; i++) {
            if (parentsArray[i] === null)
                children[i] = null;
        }

        children = children.filter(val => { return val !== null; });
    }
    return children;
}